/* eslint-disable max-lines */
export const SLIDING_WARDROBES_GALLERY_LIST_PRESET = [
  {
    displayedName: 'Белый шкаф-купе',
    addText: 'с зеркальными фасадами',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1056,
  },
  {
    displayedName: 'Белые двери-купе',
    addText: 'в серебристом профиле',
    mediaMainPhoto: ['2.jpg/02.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1009,
  },
  {
    displayedName: 'Шкаф-купе',
    addText: 'под тёмное дерево',
    mediaMainPhoto: ['3.jpg/03.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1039,
  },
  {
    displayedName: 'Шкаф-купе',
    addText: 'с зеркальными фасадами',
    mediaMainPhoto: ['4.jpg/04.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1017,
  },
  {
    displayedName: 'Шкаф-купе «Дуб»',
    addText: 'светлый с зеркалом',
    mediaMainPhoto: ['5.jpg/05.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1006,
  },
  {
    displayedName: 'Бежевый шкаф-купе',
    addText: 'с матовыми фасадами',
    mediaMainPhoto: ['6.jpg/06.jpg'],
    price: 116834,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1012,
  },
  {
    displayedName: 'Шкаф-купе «Акация»',
    addText: 'с зеркалом',
    mediaMainPhoto: ['7.jpg/07.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1013,
  },
  {
    displayedName: 'Белый шкаф-купе',
    addText: 'с декоративными вставками',
    mediaMainPhoto: ['8.jpg/08.jpg'],
    price: 71666,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1003,
  },
  {
    displayedName: 'Серый шкаф-купе',
    addText: 'матовый с зеркалом',
    mediaMainPhoto: ['9.jpg/09.jpg'],
    price: 97475,
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1048,
  },
  {
    displayedName: 'Шкаф-купе «Дуб»',
    addText: 'с зеркалом',
    mediaMainPhoto: ['10.jpg/010.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1018,
  },
  {
    displayedName: 'Серое наполнение',
    addText: 'для шкафа-купе',
    mediaMainPhoto: ['11.jpg/011.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1019,
  },
  {
    displayedName: 'Шкаф-купе',
    addText: 'с комбинированными фасадами',
    mediaMainPhoto: ['12.jpg/012.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1051,
  },
  {
    displayedName: 'Зеркальные двери-купе',
    addText: 'с декоративной вставкой',
    mediaMainPhoto: ['13.jpg/013.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 0,
  },
  {
    displayedName: 'Белый шкаф-купе',
    addText: 'в чёрном профиле',
    mediaMainPhoto: ['14.jpg/014.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1024,
  },
  {
    displayedName: 'Белый шкаф-купе',
    addText: 'с серыми глянцевыми фасадами',
    mediaMainPhoto: ['15.jpg/015.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1025,
  },
  {
    displayedName: 'Серый шкаф-купе',
    addText: '',
    mediaMainPhoto: ['16.jpg/16.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1030,
  },
  {
    displayedName: 'Шкаф-купе',
    addText: 'с зеркалом для прихожей',
    mediaMainPhoto: ['17.jpg/17.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1014,
  },
  {
    displayedName: 'Белый шкаф-купе',
    addText: 'с серыми фасадами',
    mediaMainPhoto: ['18.jpg/18.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1032,
  },
  {
    displayedName: 'Белый шкаф-купе',
    addText: 'с бежевыми фасадами',
    mediaMainPhoto: ['19.jpg/19.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1033,
  },
  {
    displayedName: 'Серый шкаф-купе',
    addText: 'с зеркалом',
    mediaMainPhoto: ['20.jpg/20.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1040,
  },
  {
    displayedName: 'Ореховый шкаф-купе',
    addText: 'с зеркальными дверьми',
    mediaMainPhoto: ['21.jpg/21.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1041,
  },
  {
    displayedName: 'Зеркальный шкаф-купе',
    addText: 'для спальни в тёплых тонах',
    mediaMainPhoto: ['22.jpg/22.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1044,
  },
  {
    displayedName: 'Шкаф-купе',
    addText: 'с фасадами и вставками',
    mediaMainPhoto: ['23.jpg/23.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1045,
  },
  {
    displayedName: 'Серый шкаф-купе',
    addText: 'с зеркалом в чёрном профиле',
    mediaMainPhoto: ['24.jpg/24.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1052,
  },
  {
    displayedName: 'Бежевый шкаф-купе ',
    addText: 'для прихожей',
    mediaMainPhoto: ['25.jpg/25.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1053,
  },
  {
    displayedName: 'Шкаф-купе с зеркалом',
    addText: 'и серыми фасадами под бетон',
    mediaMainPhoto: ['26.jpg/26.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1068,
  },
  {
    displayedName: 'Шкаф-купе',
    addText: 'в древесных тонах',
    mediaMainPhoto: ['27.jpg/27.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1069,
  },
  {
    displayedName: 'Наполнение «Дуб»',
    addText: 'для шкафа-купе',
    mediaMainPhoto: ['28.jpg/28.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1058,
  },
  {
    displayedName: 'Белое наполнение ',
    addText: 'для шкафа-купе',
    mediaMainPhoto: ['29.jpg/29.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1059,
  },
  {
    displayedName: 'Бежевое наполнение',
    addText: 'для шкафа-купе',
    mediaMainPhoto: ['30.jpg/30.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1064,
  },
  {
    displayedName: 'Бежевое наполнение',
    addText: 'для шкафа-купе',
    mediaMainPhoto: ['31.jpg/31.jpg'],
    productName: '',
    style: 'sliding-wardrobes',
    rating: 1065,
  },
];